import { ReactElement } from "react";
import { Language } from "../../i18n/config"; //
import {
  DirectionColors,
  DirectionSchemeName,
} from "../../utils/directionColors";

export type SFXSettings =
  | "disable_all"
  | "order_placed"
  | "order_filled"
  | "order_cancelled"
  | "error"
  | "points"
  | "yv_deposit";

export type OptionsChainSettings =
  | "disable_all"
  | "position"
  | "bid_iv"
  | "ask_iv"
  | "delta"
  | "mark_price";

export type LanguageSettings = "en" | "cn" | "ru";

export enum SettingsEnum {
  OPTIONS_CHAIN = "OPTIONS_CHAIN_SETTINGS",
  SFX = "SFX_SETTINGS",
  LANGUAGE = "LANGUAGE_SETTINGS",
  DIRECTION_COLORS = "DIRECTION_COLORS_SETTINGS",
  CUSTOM_DIRECTION = "CUSTOM_DIRECTION_SETTINGS",
  MARKET_SLIPPAGE = "MARKET_SLIPPAGE_BPS",
}

export type SettingsEnumToTitle = {
  [key in SettingsEnum]: string;
};

export interface ISettingsContextType {
  sfx: Set<SFXSettings>;
  addSfx: (key: SFXSettings) => void;
  removeSfx: (key: SFXSettings) => void;

  optionsChain: Set<OptionsChainSettings>;
  addOptionsChain: (key: OptionsChainSettings) => void;
  removeOptionsChain: (key: OptionsChainSettings) => void;

  language: Language;
  changeLanguage: (language: Language) => void;

  // Price up/down color scheme. `directionScheme` selects a preset (or "custom");
  // `customDirection` holds the user's custom up/down RGB triplets.
  directionScheme: DirectionSchemeName;
  customDirection: DirectionColors;
  changeDirectionScheme: (scheme: DirectionSchemeName) => void;
  setCustomDirection: (colors: DirectionColors) => void;
  // Seed a region default (once) from the geoblock country, if the user has
  // never chosen a scheme. Call from a geoblock-aware component.
  seedDirectionSchemeFromCountry: (country?: string) => void;

  /**
   * How far a MARKET order may move against the trader before it is refused,
   * in basis points. Lives here rather than in the form: it is a standing
   * preference, and the close-position modal must read the same number the
   * trade form shows.
   */
  slippageBps: number;
  setSlippageBps: (bps: number) => void;
}

export interface ISettingsContextProviderProps {
  children: ReactElement;
}
